import { render, staticRenderFns } from "./PhoneEffect.vue?vue&type=template&id=79e72bc9&scoped=true&"
import script from "./PhoneEffect.vue?vue&type=script&lang=js&"
export * from "./PhoneEffect.vue?vue&type=script&lang=js&"
import style0 from "./PhoneEffect.vue?vue&type=style&index=0&id=79e72bc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e72bc9",
  null
  
)

export default component.exports